import { useRef, useCallback, useEffect } from 'react'

interface UseAutoScrollReturn {
  messagesEndRef: React.RefObject<HTMLDivElement | null>
  scrollContainerRef: React.RefObject<HTMLDivElement | null>
  handleScroll: () => void
}

export const useAutoScroll = (deps: unknown[], threshold = 150): UseAutoScrollReturn => {
  const messagesEndRef = useRef<HTMLDivElement | null>(null)
  const scrollContainerRef = useRef<HTMLDivElement | null>(null)
  const shouldAutoScroll = useRef(true)

  const handleScroll = useCallback(() => {
    const el = scrollContainerRef.current
    if (!el) return
    shouldAutoScroll.current = el.scrollHeight - el.scrollTop - el.clientHeight < threshold
  }, [threshold])

  useEffect(() => {
    if (shouldAutoScroll.current) {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, deps)  // eslint-disable-line react-hooks/exhaustive-deps

  return { messagesEndRef, scrollContainerRef, handleScroll }
}
